import { useQuery } from '@tanstack/react-query'
import { StripeAPI } from '@apis'

export function usePaymentMethods(userId: string | undefined | null) {
    return useQuery({
        queryKey: ['payment-methods', userId],
        queryFn: () => StripeAPI.GetPaymentMethodsRequest.fetch(userId || undefined),
        enabled: !!userId,
        staleTime: 600000 // 10 minutes
    })
}
